const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const Locales = ['ja', 'ja-Hira', 'en'];

const Message = {
    whenGamepadButtonPressed: {
        'en': 'when Gamepad [BUTTON] button pressed',
        'ja': 'ゲームパッドのボタン [BUTTON] が押された時',
        'ja-Hira': 'ゲームパッドのボタン [BUTTON] がおされたとき',
    },
    whenGamepadButtonReleased: {
        'en': 'when Gamepad [BUTTON] button released',
        'ja': 'ゲームパッドのボタン [BUTTON] が離された時',
        'ja-Hira': 'ゲームパッドのボタン [BUTTON] がはなされたとき',
    },
    whenGamepadAxisChanged: {
        'en': 'when Gamepad [AXIS] changed',
        'ja': 'ゲームパッドの [AXIS] が変化したとき',
        'ja-Hira': 'ゲームパッドの [AXIS] がかわったとき',
    },
    valueJoystickX: {
        'en':'joystick Left X value',
        'ja':'左スティックXの値',
        'ja-Hira':'ひだりスティックXのあたい',
    },
    valueJoystickY: {
        'en':'joystick Left Y value',
        'ja':'左スティックYの値',
        'ja-Hira':'ひだりスティックYのあたい',
    },

};

class Scratch3GamepadExtension {

    constructor(runtime) {
        this.runtime = runtime;
        this.locale = this._getViewerLanguageCode();

        // ボタンの状態を保持するオブジェクト
        this.buttonStates = {};
         // 軸の状態を保持するオブジェクト
        this.axisStates = {};
       
        this.axis9Value = 1.2; // 初期値

        // ジョイスティックの値
        this.joystickX_before = 0;
        this.joystickY_before = 0;
        this.joystickX = 0;
        this.joystickY = 0;

        setInterval(() => this.updateButtonStates(), 16);
    }

    _getViewerLanguageCode() {
        const locale = formatMessage.setup().locale;
        if (Locales.includes(locale)) {
            return locale;
        }
        return 'en';
    }

    updateButtonStates() {
        const gamepads = navigator.getGamepads();
        if (gamepads[0]) {
            const buttons = gamepads[0].buttons;
            for (let i = 0; i < buttons.length; i++) {
                const pressed = buttons[i].pressed;
                if (!this.buttonStates[i]) {
                    // 初回は前回と現在の状態を同じにする
                    this.buttonStates[i] = { pressedBefore: pressed, pressedNow: pressed };
                } else {
                    // 状態を更新
                    this.buttonStates[i].pressedBefore = this.buttonStates[i].pressedNow;
                    this.buttonStates[i].pressedNow = pressed;
                }
            }

            const axes = gamepads[0].axes;
            for (let i = 0; i < axes.length; i++) {
                const value = Math.round(axes[i]);
                if (!this.axisStates[i]) {
                    this.axisStates[i] = { valueBefore: value, valueNow: value };
                } else {
                    this.axisStates[i].valueBefore = this.axisStates[i].valueNow;
                    this.axisStates[i].valueNow = value;
                }
            }

            // D-padの状態も同様に更新
            this.axis9PreviousValue = this.axis9CurrentValue || 1.2;
            this.axis9CurrentValue = gamepads[0].axes[9];

            this.joystickX = Math.round(gamepads[0].axes[0]*100);
            this.joystickY = Math.round(gamepads[0].axes[1]*100);
        }
    }

    getInfo() {
        this.locale = this._getViewerLanguageCode();
        return {
            id: 'gamepad',
            name: 'Gamepad',
            color1: '#36C2CE',  // 主色
            color2: '#36C2CE',  // 二次色
            color3: '#191970',  // 三次色
            // blockIconURI: blockIconURI, // アイコン変えたければこれ
            blocks: [
                {
                    opcode: 'whenGamepadButtonPressed',
                    blockType: BlockType.HAT,
                    text: Message.whenGamepadButtonPressed[this.locale],
                    arguments: {
                        BUTTON: {
                            type: ArgumentType.STRING,
                            menu: 'gamepadButtons',
                            defaultValue: 'A'
                        }
                    }
                },
                {
                    opcode: 'whenGamepadButtonReleased',
                    blockType: BlockType.HAT,
                    text: Message.whenGamepadButtonReleased[this.locale],
                    arguments: {
                        BUTTON: {
                            type: ArgumentType.STRING,
                            menu: 'gamepadButtons',
                            defaultValue: 'A'
                        }
                    }
                },

                {
                    opcode: 'whenGamepadAxisChanged',
                    blockType: BlockType.HAT,
                    text: Message.whenGamepadAxisChanged[this.locale],
                    arguments: {
                        AXIS: {
                            type: ArgumentType.STRING,
                            menu: 'gamepadAxis',
                            defaultValue: 'X'
                        }
                    }
                },
                {
                    opcode: 'getJoystickX',
                    blockType: BlockType.REPORTER,
                    text: Message.valueJoystickX[this.locale],
                },
                {
                    opcode: 'getJoystickY',
                    blockType: BlockType.REPORTER,
                    text: Message.valueJoystickY[this.locale],
                },
                {
                    opcode: 'getAxisValue',
                    blockType: BlockType.REPORTER,
                    text: 'Axis [AXIS_INDEX] value',
                    arguments: {
                        AXIS_INDEX: {
                            type: ArgumentType.NUMBER,
                            menu: 'axisIndices',
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'getButtonValue',
                    blockType: BlockType.BOOLEAN,
                    text: 'Button [BUTTON_INDEX] pressed',
                    arguments: {
                        BUTTON_INDEX: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        }
                    }
                }

            ],
            menus: {
                gamepadAxis: {
                    acceptReporters: true,
                    items: ['X', 'Y', 'ANY']
                },
                gamepadButtons: {
                    acceptReporters: true,
                    items: ['A', 'B', 'X', 'Y', 'L1', 'R1', 'L2', 'R2', 'UP', 'DOWN', 'LEFT', 'RIGHT']
                },
                axisIndices: {
                    acceptReporters: true,
                    items: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
                }
            }
        };
    }

    updateGamepadValues() {
        const gamepads = navigator.getGamepads();
        if (gamepads[0]) {
            this.joystickX = Math.round(gamepads[0].axes[0]*100);
            this.joystickY = Math.round(gamepads[0].axes[1]*100);

            // Axis9 の値を取得
            this.axis9Value = gamepads[0].axes[9];
        }
    }
    getButtonValue(args) {
        const gamepads = navigator.getGamepads();
        const buttonIndex = args.BUTTON_INDEX;
        if (gamepads[0] && gamepads[0].buttons.length > buttonIndex) {
            return gamepads[0].buttons[buttonIndex].pressed;
        }
        return false;
    }

    getAxisValue(args) {
        const gamepads = navigator.getGamepads();
        const axisIndex = args.AXIS_INDEX;
        if (gamepads[0] && gamepads[0].axes.length > axisIndex) {
            return gamepads[0].axes[axisIndex];
        }
        return 0;
    }

    isDpadPressed(direction, action) {
        const previousValue = this.axis9PreviousValue;
        const currentValue = this.axis9CurrentValue;
        const threshold = 0.2;
    
        const directionValues = {
            'UP': -1,
            'DOWN': 0.14,
            'LEFT': 0.71,
            'RIGHT': -0.4
        };
    
        const isPressedBefore = Math.abs(previousValue - directionValues[direction]) < threshold;
        const isPressedNow = Math.abs(currentValue - directionValues[direction]) < threshold;
    
        if (action === 'pressed') {
            return !isPressedBefore && isPressedNow;
        } else if (action === 'released') {
            return isPressedBefore && !isPressedNow;
        }
        return false;
    }


    getJoystickX() {
        return this.axisStates[0] ? this.axisStates[0].valueNow : 0;
    }
    
    getJoystickY() {
        return this.axisStates[1] ? this.axisStates[1].valueNow : 0;
    }

    whenGamepadButtonPressed(args) {
        const buttonIndex = this.getButtonIndex(args.BUTTON);
        if (buttonIndex !== undefined && this.buttonStates[buttonIndex]) {
            const state = this.buttonStates[buttonIndex];
            if (!state.pressedBefore && state.pressedNow) {
                return true;
            }
        } else if (args.BUTTON === 'UP' || args.BUTTON === 'DOWN' || args.BUTTON === 'LEFT' || args.BUTTON === 'RIGHT') {
            return this.isDpadPressed(args.BUTTON, 'pressed');
        }
        return false;
    }
    
    whenGamepadButtonReleased(args) {
        const buttonIndex = this.getButtonIndex(args.BUTTON);
        if (buttonIndex !== undefined && this.buttonStates[buttonIndex]) {
            const state = this.buttonStates[buttonIndex];
            if (state.pressedBefore && !state.pressedNow) {
                return true;
            }
        } else if (args.BUTTON === 'UP' || args.BUTTON === 'DOWN' || args.BUTTON === 'LEFT' || args.BUTTON === 'RIGHT') {
            return this.isDpadPressed(args.BUTTON, 'released');
        }
        return false;
    }

    getButtonIndex(buttonName) {
        const mapping = {
            'A': 0,
            'B': 1,
            'X': 3,
            'Y': 4,
            'L1': 6,
            'R1': 7,
            'L2': 8,
            'R2': 9,
            'LS': 13,
            'RS': 14
        };
        return mapping[buttonName];
    }    

    whenGamepadAxisChanged(args) {
        if (args.AXIS === 'X' && this.axisStates[0]) {
            if (this.axisStates[0].valueBefore !== this.axisStates[0].valueNow) {
                return true;
            }
        } else if (args.AXIS === 'Y' && this.axisStates[1]) {
            if (this.axisStates[1].valueBefore !== this.axisStates[1].valueNow) {
                return true;
            }
        } else if (args.AXIS === 'ANY') {
            const axisXChanged = this.axisStates[0] && this.axisStates[0].valueBefore !== this.axisStates[0].valueNow;
            const axisYChanged = this.axisStates[1] && this.axisStates[1].valueBefore !== this.axisStates[1].valueNow;
            if (axisXChanged || axisYChanged) {
                return true;
            }
        }
        return false;
    }
}

module.exports = Scratch3GamepadExtension;
